// src/data/movieAliases.js
// Only titles that genuinely need help matching OMDb belong here.

const movieAliases = {
  "500 Days of Summer": {
    title: "(500) Days of Summer",
  },

  "Bad Boys 2": {
    title: "Bad Boys II",
    year: "2003",
    imdbId: "tt0172156",
  },

  "Bad Boys II": {
    title: "Bad Boys II",
    year: "2003",
    imdbId: "tt0172156",
  },

  "Carlitos Way": {
    title: "Carlito's Way",
  },

  
  "The Boat": {
    title: "Das Boot",
    year: "1981",
    imdbId: "tt0082096",
    wikipedia: "Das_Boot",
  },

  "The Raid": {
    title: "The Raid: Redemption",
    year: "2011",
    imdbId: "tt1899353",
    wikipedia: "The_Raid:_Redemption",
  },

  "The Girl with the Dragon Tattoo": {
    title: "The Girl with the Dragon Tattoo",
    year: "2011",
    imdbId: "tt1568346",
  },

  "The Girl with the Dragon Tattoo (2009)": {
    title: "The Girl with the Dragon Tattoo",
    year: "2009",
    imdbId: "tt1132620",
  },

  "Harry Potter 1": {
    title: "Harry Potter and the Philosopher's Stone",
    year: "2001",
    imdbId: "tt0241527",
  },

  "Edge of Tomorrow": {
    title: "Edge of Tomorrow",
    year: "2014",
    imdbId: "tt1631867",
    wikipedia: "Edge_of_Tomorrow",
  },

  "Birdman": {
    title: "Birdman or (The Unexpected Virtue of Ignorance)",
    year: "2014",
    imdbId: "tt2562232",
    wikipedia: "Birdman_(film)",
  },

  "Three Colours: Red": {
    title: "Three Colours: Red",
    year: "1994",
    imdbId: "tt0111495",
  },

  "Three Colours: Blue": {
    title: "Three Colours: Blue",
    year: "1993",
    imdbId: "tt0108394",
  },

  "Three Colours: White": {
    title: "Three Colours: White",
    year: "1994",
    imdbId: "tt0111507",
  },

  "Crouching Tiger Hidden Dragon": {
    title: "Crouching Tiger, Hidden Dragon",
  },

  "Dont Look Now": {
    title: "Don't Look Now",
  },

  "Dr Strangelove": {
    title: "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
    year: "1964",
    imdbId: "tt0057012",
  },

  "Extraction": {
    title: "Extraction",
    year: "2020",
    imdbId: "tt8936646",
  },

  "Extraction 2": {
    title: "Extraction 2",
    year: "2023",
    imdbId: "tt12263384",
  },

  "Fantastic Mr Fox": {
    title: "Fantastic Mr. Fox",
  },

  "Furiosa A Mad Max Saga": {
    title: "Furiosa: A Mad Max Saga",
  },

  "Kill Bill Volume 1": {
    title: "Kill Bill: Vol. 1",
    year: "2003",
    imdbId: "tt0266697",
  },

  "Kill Bill Volume 2": {
    title: "Kill Bill: Vol. 2",
    year: "2004",
    imdbId: "tt0378194",
  },

  "Kingsman 2": {
    title: "Kingsman: The Golden Circle",
    year: "2017",
    imdbId: "tt4649466",
  },

  "Love Rosie": {
    title: "Love, Rosie",
  },

  "Mad Max Fury Road": {
    title: "Mad Max: Fury Road",
    year: "2015",
    imdbId: "tt1392190",
  },

  "Mission Impossible 3": {
    title: "Mission: Impossible III",
    year: "2006",
    imdbId: "tt0317919",
  },

  "Mission Impossible III": {
    title: "Mission: Impossible III",
    year: "2006",
    imdbId: "tt0317919",
  },

  "Mission: Impossible 3": {
    title: "Mission: Impossible III",
    year: "2006",
    imdbId: "tt0317919",
  },

  "Mission Impossible Fallout": {
    title: "Mission: Impossible - Fallout",
    year: "2018",
    imdbId: "tt4912910",
  },

  "Mission Impossible Ghost Protocol": {
    title: "Mission: Impossible - Ghost Protocol",
    year: "2011",
    imdbId: "tt1229238",
  },

  "Mr Smith Goes to Washington": {
    title: "Mr. Smith Goes to Washington",
  },

  "Rosemarys Baby": {
    title: "Rosemary's Baby",
    year: "1968",
    imdbId: "tt0063522",
  },

  Seven: {
    title: "Se7en",
    year: "1995",
    imdbId: "tt0114369",
  },

  Se7en: {
    title: "Se7en",
    year: "1995",
    imdbId: "tt0114369",
  },

  "Sympathy for Mr Vengeance": {
    title: "Sympathy for Mr. Vengeance",
  },

  "Synecdoche New York": {
    title: "Synecdoche, New York",
  },

  "Terminator 2 Judgment Day": {
    title: "Terminator 2: Judgment Day",
    year: "1991",
    imdbId: "tt0103064",
  },

  "The Blackcoats Daughter": {
    title: "The Blackcoat's Daughter",
  },

  "The Cabinet of Dr Caligari": {
    title: "The Cabinet of Dr. Caligari",
  },

  "The Talented Mr Ripley": {
    title: "The Talented Mr. Ripley",
  },

  "When Harry Met Sally": {
    title: "When Harry Met Sally...",
    year: "1989",
    imdbId: "tt0098635",
  },

  "Youre Next": {
    title: "You're Next",
  },

  "The Rock": {
  title: "The Rock",
  year: "1996",
  imdbId: "tt0117500",
  wikipedia: "The_Rock_(1996_film)",
},

"Black Swan": {
  title: "Black Swan",
  year: "2010",
  imdbId: "tt0947798",
  wikipedia: "Black_Swan_(film)",
},

"Borat 2": {
  title: "Borat Subsequent Moviefilm",
  year: "2020",
  imdbId: "tt13143964",
  wikipedia: "Borat_Subsequent_Moviefilm",
},

"Seven": {
  title: "Se7en",
  year: "1995",
  imdbId: "tt0114369",
  wikipedia: "Se7en",
},
};

const ROMAN_TO_NUMBER = {
  ii: "2",
  iii: "3",
  iv: "4",
  v: "5",
  vi: "6",
  vii: "7",
  viii: "8",
  ix: "9",
  x: "10",
};

const normalizeAliasTitle = (value = "") =>
  String(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’‘]/g, "'")
    .replace(/[–—]/g, "-")
    .replace(/&/g, " and ")
    .replace(/\b(ii|iii|iv|v|vi|vii|viii|ix|x)\b/gi, (match) => {
      return ROMAN_TO_NUMBER[match.toLowerCase()] || match;
    })
    .replace(/[^a-z0-9]+/gi, " ")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

const cleanAliasInput = (value = "") =>
  String(value)
    .replace(/\(\s*\d{4}\s*\)/g, "")
    .replace(/\[\s*\d{4}\s*\]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const aliasIndex = Object.entries(movieAliases).reduce(
  (index, [datasetTitle, match]) => {
    const datasetKey = normalizeAliasTitle(datasetTitle);
    const resolvedKey = normalizeAliasTitle(match.title);

    index[datasetKey] = match;

    // Avoid unnecessarily replacing an existing alias.
    if (!index[resolvedKey]) {
      index[resolvedKey] = match;
    }

    return index;
  },
  {}
);

const resolveMovieAlias = (title = "") => {
  const originalTitle = String(title).trim();
  const cleanedTitle = cleanAliasInput(originalTitle);

  return (
    movieAliases[originalTitle] ||
    movieAliases[cleanedTitle] ||
    aliasIndex[normalizeAliasTitle(originalTitle)] ||
    aliasIndex[normalizeAliasTitle(cleanedTitle)] || {
      title: cleanedTitle || originalTitle,
    }
  );
};

export const getMovieImdbId = (title = "") =>
  resolveMovieAlias(title).imdbId || null;

export default resolveMovieAlias;